import * as React from "react";
import { useDataProvider } from "react-admin";

type UnreadCountRow = { id: number; count: number };

export function useInboxUnreadCount(pollMs: number = 15000, clubId?: number | null) {
  const dataProvider = useDataProvider();
  const [count, setCount] = React.useState<number>(0);

  const load = React.useCallback(async () => {
    try {
      const filter: any = {};
      if (clubId != null) filter.club_id = clubId;

      const res = await dataProvider.getList("messages/unread-count", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "ASC" },
        filter,
      } as any);

      const row = (res?.data?.[0] as UnreadCountRow | undefined);
      setCount(Number.isFinite(row?.count) ? row!.count : 0);
    } catch {
      // leise failen, Badge soll nicht nerven
      setCount(0);
    }
  }, [dataProvider, clubId]);

  React.useEffect(() => {
    load();
    const t = setInterval(load, pollMs);
    return () => clearInterval(t);
  }, [load, pollMs]);

  return count;
}
